var cssVars = require('./helpers/css-vars');
require('./helpers/request-animation-frame');

$(document).on('keypress keydown', function(event) {
	if (event.keyCode !== 27 || !$(document.activeElement).is('.search__input')) {
		return;
	}

	// search is active
	$('.search__state').prop('checked', false);
});

$(document).on('change.search', '.search__state', function() {
	if (this.checked && Modernizr.mq('(min-width: ' + cssVars['size-md'] + ')')) {
		requestAnimationFrame(function() {
			$('.search__input').focus();
		});
	}
});

var selector = '.search__input, .search__button';
$(document).on('blur', selector, function(event) {
	if (!Modernizr.mq('(min-width: ' + cssVars['size-md'] + ')')) {
		return;
	}

	if ($(event.relatedTarget).closest(selector).length) {
		return;
	}

	// search is active
	$('.search__state').prop('checked', false);
});
